export default __webpack_public_path__ + "static/media/calendar-blue.d0c7dc9a.svg";